import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {ProductsView} from "../views/products";

export class ProductsFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new ProductsView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/products`;
    }

    isCacheable(): boolean {
        return true;
    }
}
